module.exports = require("remark-comment-config");


//////////////////
// WEBPACK FOOTER
// external "remark-comment-config"
// module id = 54
// module chunks = 0 1 2 3 4 5 6 7 8 9 12 13